import React, { useState, useEffect } from "react";
import styles from "../css/Usuarios.module.css";
import miAxios from "../api/axios";
import {
    Button,
    TextField,
    Grid2,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Switch,
    FormControlLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Snackbar,
    Alert
} from "@mui/material";
import { useAuth } from "../hooks/AuthProvider";
import Confirmacion from "../components/Conformacion";
import Wait from "../components/Wait";

export default function Usuarios() {
    const [idUsuario, setIdUsuario] = useState(0);
    const [usuario, setUsuario] = useState("");
    const [inactivo, setInactivo] = useState(false)
    const [clave, setClave] = useState("");
    const [confirmacion, setConfirmacion] = useState("");
    const [nombre, setNombre] = useState("");
    const [celular, setCelular] = useState("");
    const [permisosMenu, setPermisosMenu] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [usuariosLista, setUsuariosLista] = useState([]);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
    const [mensaje, setMensaje] = useState("");
    const [openConfirmacion, setOpenConfirmacion] = useState(false)
    const [procesando, setProcesando] = useState(false)

    const user = useAuth();
    const axios = miAxios(user.handleLogout);

    useEffect(()=>{
        handleNuevoUsuario()
    }, [])

    const actPermisos = async (cual) => {
        const response = await axios.get("usuarios/prov-permisos-lista?usuario=" + cual);
        const data = response.data;
        if (data.respuesta == "S") {
            const n = data.lista.map((item) => {
                return {
                    id: item.id,
                    texto: item.descripcion,
                    seleccionado: item.marca == 1 ? true : false
                }
            })
            setPermisosMenu(n);
        }
    }

    const handleNuevoUsuario = () => {
        setIdUsuario(0)
        setUsuario("");
        setClave("");
        setConfirmacion("");
        setNombre("");
        setCelular("");
        setUsuarioSeleccionado(null);
        setInactivo(false)
        // Limpiar permisos
        setPermisosMenu(permisosMenu.map(p => ({ ...p, seleccionado: false })));
        setMensaje("");
        actPermisos(0)
    };

    const handleCambiarPermiso = (id) => {
        setPermisosMenu(permisosMenu.map(p =>
            p.id === id ? { ...p, seleccionado: !p.seleccionado } : p
        ));
    };

    const puedeGrabar = () => {
        if (!usuario.trim()) {
            setMensaje("Debe ingresar un usuario");
            return false;
        }
        if (idUsuario == 0) {
            if (!clave.trim()) {
                setMensaje("Debe ingresar una clave");
                return false;
            }
        }

        if (clave !== confirmacion) {
            setMensaje("Las claves no coinciden");
            return false;
        }
        if (!nombre.trim()) {
            setMensaje("Debe ingresar el nombre del usuario");
            return false;
        }
        return true
    }

    const handleGrabar = async () => {
        // Validaciones básicas
        if (!puedeGrabar()) { return; }

        const n = permisosMenu.filter((r) => r.seleccionado).map((r) => {return {permiso: r.id}});

        setOpenConfirmacion(false)
        setProcesando(true)

        try {
            const response = await axios.post("/proveedores/grabar-usuario-regular", {
                id: idUsuario,
                usuario: usuario,
                nombre: nombre,
                clave: clave,
                inactivo: inactivo ? -1 : 0,
                celular: celular,
                permisos: JSON.stringify(n)
            })

            const data = response.data;
            if (data.respuesta == "S") {
                handleNuevoUsuario()
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    };

    const handleAbrirDialog = async () => {
        // Aquí se cargará la lista de usuarios desde la API más adelante
        // Por ahora, inicializamos con un array vacío
        //setUsuariosLista([]);
        setOpenDialog(true);


        setProcesando(true)

        try {
            const response = await axios.get("/proveedores/usuarios-regular-lista?incluir_inactivos=0")

            const data = response.data;
            if (data.respuesta == "S") {
                setUsuariosLista(data.lista)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)

    };

    const handleCerrarDialog = () => {
        setOpenDialog(false);
        setUsuarioSeleccionado(null);
    };

    const handleSeleccionarUsuario = (usuarioItem) => {
        handleCerrarDialog();
        if ((usuarioItem.id || 0) == 0) { return; }
        handleInicio(usuarioItem.id)
    };

    const handleConfirmar = () => {
        if (puedeGrabar()) {
            setOpenConfirmacion(true)
        }
    }

    const handleInicio = async (cual) => {
        setProcesando(true)

        try {
            const response = await axios.get("/proveedores/inicio-usuario-regular?cual=" + cual)

            const data = response.data;
            if (data.respuesta == "S") {
                setIdUsuario(data.id)
                setUsuario(data.usuario)
                setNombre(data.nombre)
                setCelular(data.celular)
                setInactivo(parseInt(data.inactivo) == 0 ? false : true)
                setClave("")
                setConfirmacion("")
                actPermisos(cual)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    };

    return (
        <div className={styles.cuerpo}>
            <div className={styles.header}>
                Gestión de Usuarios
            </div>

            <Snackbar
                open={mensaje.length > 0}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={() => setMensaje("")}
            >
                <Alert
                    severity={mensaje.includes("pendiente") ? "info" : "error"}
                    onClose={() => setMensaje("")}
                    variant="filled"
                >
                    {mensaje}
                </Alert>
            </Snackbar>
            {
                openConfirmacion && (
                    <Confirmacion
                        open={openConfirmacion}
                        texto="¿Desea grabar este usuario?"
                        cancelar={() => { setOpenConfirmacion(false) }}
                        exito={handleGrabar}
                    />
                )
            }
            {
                procesando && (
                    <Wait open={procesando} />
                )
            }

            <Paper elevation={3} className={styles.formulario}>
                <div className={styles.formularioHeader}>
                    <h2 className={styles.titulo}>
                        {idUsuario ? "Editar Usuario" : "Nuevo Usuario"}
                    </h2>
                </div>

                <div className={styles.contenidoPrincipal}>
                    <div className={styles.formularioIzquierdo}>
                        <Grid2 container spacing={3} className={styles.grid}>
                            <Grid2 size={{ xs: 8, sm: 10 }}>
                                <TextField
                                    color="coopinfa"
                                    label="Nombre del Usuario"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 4, sm: 2 }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={inactivo}
                                            onChange={(event) => setInactivo(event.target.checked)}
                                            color="coopinfa"
                                        />
                                    }
                                    label={"Inactivo"}
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    color="coopinfa"
                                    label="Usuario"
                                    value={usuario}
                                    onChange={(e) => setUsuario(e.target.value)}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    disabled={!!usuarioSeleccionado}
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 6 }}>

                            </Grid2>


                            <Grid2 size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    color="coopinfa"
                                    label="Clave"
                                    type="password"
                                    value={clave}
                                    onChange={(e) => setClave(e.target.value)}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    color="coopinfa"
                                    label="Confirmación de Clave"
                                    type="password"
                                    value={confirmacion}
                                    onChange={(e) => setConfirmacion(e.target.value)}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    color="coopinfa"
                                    label="Celular"
                                    value={celular}
                                    onChange={(e) => setCelular(e.target.value)}
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid2>
                        </Grid2>
                    </div>

                    <div className={styles.permisosContainer}>
                        <h3 className={styles.permisosTitulo}>Permisos</h3>
                        <div className={styles.permisosLista}>
                            {permisosMenu.map((permiso) => (
                                <FormControlLabel
                                    key={permiso.id}
                                    control={
                                        <Switch
                                            checked={permiso.seleccionado}
                                            onChange={() => handleCambiarPermiso(permiso.id)}
                                            color="coopinfa"
                                        />
                                    }
                                    label={permiso.texto}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                <div className={styles.botones}>
                    <Button
                        variant="outlined"
                        color="coopinfa"
                        onClick={handleNuevoUsuario}
                        className={styles.boton}
                    >
                        Nuevo Usuario
                    </Button>
                    <Button
                        variant="outlined"
                        color="coopinfa"
                        onClick={handleAbrirDialog}
                        className={styles.boton}
                    >
                        Buscar Usuario
                    </Button>
                    <Button
                        variant="contained"
                        color="coopinfa"
                        onClick={handleConfirmar}
                        className={styles.boton}
                    >
                        Grabar
                    </Button>
                </div>
            </Paper>

            {/* Dialog para seleccionar usuario */}
            <Dialog
                open={openDialog}
                onClose={handleCerrarDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Seleccionar Usuario</DialogTitle>
                <DialogContent>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Usuario</TableCell>
                                    <TableCell>Nombre</TableCell>
                                    <TableCell>Nivel</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {usuariosLista.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    usuariosLista.map((usr) => (
                                        <TableRow
                                            key={usr.id}
                                            hover
                                            onDoubleClick={() => { if (usr.nivel == "Regular") { handleSeleccionarUsuario(usr) } else { setMensaje("Usuarios administradores no pueden editarse") } }}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <TableCell>{usr.usuario}</TableCell>
                                            <TableCell>{usr.nombre}</TableCell>
                                            <TableCell>{usr.nivel}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCerrarDialog} color="coopinfa">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

